// extracted by mini-css-extract-plugin
module.exports = {"container":"device-status_container_30CG5","noDataBox":"device-status_noDataBox_1RdzL","icon":"device-status_icon_2LT_O","chartBox":"device-status_chartBox_kOUOf"};